export default __webpack_public_path__ + "0b02aa0151c2b1baf443e36c8a3b2d81.glb";